import React from 'react'

const FiveMetodePembayaranCorporate = (props) => {

    return (
        <>
            <div className='row' style={{ marginLeft: '5px', marginTop: '2%' }}>
                <h5 style={{ color: '#26D07C', marginBottom: '3%', fontSize: '16px', fontWeight: '700' }}>Metode Pembayaran</h5>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Metode Pembayaran</label>
                    <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '18px', fontWeight: '500' }}>{props.categoryUser.value}</p>
                    <hr className='mt-0'></hr>
                </div>
                <div className='row'>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama Perusahaan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.namaPerusahaan}</p>
                    </div>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Jenis Perusahaan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.jenisPerusahaan}</p>
                    </div>
                    <hr className='mt-0'></hr>
                </div>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Klasifikasi Industri</label>
                    <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.klasifikasiIndustri}</p>
                    <hr className='mt-0'></hr>
                </div>
                <div className='row'>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>No. NPWP Perusahaan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.stringNpwpPerusahaan}</p>
                    </div>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>No. Telepon Perusahaan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.teleponPerusahaan}</p>
                    </div>
                    <hr className='mt-0'></hr>
                </div>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Alamat Perusahaan</label>
                    <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.patokanPerusahaan} {props.dataInputRegistration.kecamatanPerusahaan} {props.dataInputRegistration.kotaPerusahaan} {props.dataInputRegistration.provinsiPerusahaan} {props.dataInputRegistration.kodeposPerusahaan}</p>
                    <hr className='mt-0'></hr>
                </div>

                {
                    props.dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan === true ?
                        <div className='col-lg-12'>
                            <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Alamat Pengiriman Dokumen</label>
                            <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.patokanPerusahaanPengirimanDokumen} {props.dataInputRegistration.kecamatanPerusahaanPengirimanDokumen} {props.dataInputRegistration.kotaPerusahaanPengirimanDokumen} {props.dataInputRegistration.provinsiPerusahaanPengirimanDokumen} {props.dataInputRegistration.kodeposPerusahaanPengirimanDokumen}</p>
                            <hr className='mt-0'></hr>
                        </div>
                        :
                        ''
                }

            </div>
        </>
    )
}

export default FiveMetodePembayaranCorporate
